<template lang="html">
  <div tabindex="-1" :class="isFocus ? 'ky-editor-wrapper':''" @focusin="inProxy" @focusout="outProxy">
    <quill-editor v-model="content"
      ref="myQuillEditor"
      @change="onChange"
      :options="editorOption">
    </quill-editor>
    <el-dialog title="上传图片" size="tiny" :visible.sync="isUploadShow">
      <el-upload
        class="upload-demo"
        action="//upload-z2.qiniup.com"
        :data="uploadForm"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-success="importSuccess"
        :on-error="importError"
        >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传JPG/PNG文件，且大小不超过500K</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
  import sessionstorage from 'utils/sessionstorage'
  import CommonModel from 'models/common'
  import date from 'utils/date'
  // VUE 富文本编辑器
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  export default {
    name: 'KyEditor',
    props: ['value'],
    components: {
      quillEditor
    },
    data () {
      return {
        content: '',
        editorOption: {
          placeholder: '请输入内容……',
          modules: {
            toolbar: {
              container: [
                ['bold', 'underline'],
                ['image'],
              ],
              handlers: {
                'image': this.customImageHandler
              }
            }
          }
        },
        isUploadShow: false,
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        isFocus: false
      }
    },
    computed: {
      editor () {
        return this.$refs.myQuillEditor.quill
      }
    },
    mounted () {
      this.content = this.value
    },
    watch: {
      'value' (newVal, oldVal) {
        if (this.editor) {
          if (newVal !== this.content) {
            this.content = newVal
          }
        }
      },
    },
    methods: {
      customImageHandler () {
        this.isUploadShow = true
      },
      beforeUpload (file) {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        if (!isJPG && !isPNG) {
          this.$message({ message: '文件不是JPG或者PNG格式', type: 'error' })
          return false
        }
        if (file.size > 500 * 1024) {
          this.$message({ message: '文件超过了500K，无法上传', type: 'error' })
          return false
        }
        let curr = date(new Date().getTime(), 'yyyyMMdd')
        let prefix = 'article'
        let ext = file.name.split('.').pop()
        let suffix = this.$md5(file.name)
        if (!this.uploadForm.token) {
          return sessionstorage.getItem('key').then(key => {
            return CommonModel.getQiniuUptoken({
              key
            })
          }).then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}.${ext}`)
            console.log(this.uploadForm)
          })
        } else {
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}.${ext}`)
          console.log(this.uploadForm)
        }
        return true
      },
      importSuccess (res) {
        this.isUploadShow = false
        let index = this.editor.getSelection().index === null ? 0 : this.editor.getSelection().index
        this.editor.insertEmbed(index, 'image', this.qiniuHost + res.key)
        this.$message({ message: '上传成功', type: 'success' })
      },
      importError () {
        this.$message({ message: '上传失败', type: 'error' })
      },
      onChange () {
        this.$emit('input', this.content)
      },
      inProxy: function (event) {
        this.isFocus = true
      },
      outProxy: function (event) {
        this.isFocus = false
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .ky-editor-wrapper
    border: solid 1px  #5fb878
</style>



// WEBPACK FOOTER //
// src/components/KyEditor.vue